var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { getService, ThirdPartyAuthenticationService } from '@shared/utils/ThirdPartyAuthentication/IAuthenticationService';
import { DataCache } from '../DataCache';
import { AuthenticationType } from '@shared/utils/ThirdPartyAuthentication/AuthenticationType';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { AuthenticationResponseType } from '@shared/utils/ThirdPartyAuthentication/AuthenticationResponseType';
export class ThirdPartyProvidersValidator {
    get thirdPartyProvider() {
        return this._thirdPartyProvider;
    }
    attachProvider(thirdPartyProvider) {
        this._thirdPartyProvider = thirdPartyProvider;
    }
    validateLoginAsync(vendor, login) {
        return __awaiter(this, void 0, void 0, function* () {
            if (isNullOrUndefined(this._thirdPartyProvider)) {
                return true;
            }
            const certificateLoginServiceProvider = getService(ThirdPartyAuthenticationService.CertificateLogin, this._thirdPartyProvider);
            if (!isNullOrUndefined(certificateLoginServiceProvider)) {
                return yield this.validateCertificateAsync(vendor, login);
            }
            else {
                return true;
            }
        });
    }
    validateTradingAsync(vendor, login, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () {
            const tradingServiceProvider = getService(ThirdPartyAuthenticationService.Trading, this._thirdPartyProvider);
            if (isNullOrUndefined(tradingServiceProvider)) {
                return true;
            }
            const account = DataCache.GetAccountByUserLogin(login);
            if (isNullOrUndefined(account)) {
                vendor.generateRejectMessage(`Account ${login} not found`);
                return false;
            }
            const certificateLoginServiceProvider = getService(ThirdPartyAuthenticationService.CertificateLogin, this._thirdPartyProvider);
            if (!isNullOrUndefined(certificateLoginServiceProvider) &&
                !this.isValidateCertificateOnTrading(this._thirdPartyProvider.type, account)) {
                return true;
            }
            const isAllowTradingResponse = yield tradingServiceProvider.isAllowTrading(login);
            const informationMessage = isAllowTradingResponse.Result.informationMessage;
            if (!isNullOrUndefined(informationMessage)) {
                const content = {
                    accountId: account.ID,
                    clientPanelId: isValidNumber(placedFrom) ? placedFrom.toString() : '',
                    description: informationMessage.message
                };
                void vendor.SendInformationMessage({ msgType: informationMessage.type, content, timestamp: new Date() });
            }
            if (isAllowTradingResponse.ResponseType === AuthenticationResponseType.Error &&
                isValidString(isAllowTradingResponse.Result.result)) {
                vendor.generateRejectMessage(isAllowTradingResponse.Result.result);
            }
            return isAllowTradingResponse.ResponseType === AuthenticationResponseType.Success;
        });
    }
    // #region Certificate Validation
    validateCertificateAsync(vendor, login) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = DataCache.GetAccountByUserLogin(login);
            if (isNullOrUndefined(account)) {
                return false;
            }
            const type = this._thirdPartyProvider.type;
            if (!this.isValidateCertificateOnLogin(type, account)) {
                return true;
            }
            const certificateLoginServiceProvider = this
                ._thirdPartyProvider;
            const response = yield certificateLoginServiceProvider.checkCertificate(login);
            const isSuccess = response.ResponseType === AuthenticationResponseType.Success;
            const informationMessage = response.Result.informationMessage;
            if (!isNullOrUndefined(informationMessage)) {
                const content = { description: informationMessage.message };
                void vendor.SendInformationMessage({ msgType: informationMessage.type, content, timestamp: new Date() });
            }
            return isSuccess;
        });
    }
    isValidateCertificateOnLogin(authenticationType, account) {
        switch (authenticationType) {
            case AuthenticationType.CapitalFutures:
                return DataCache.isAllowedForAccount(RulesSet.CA_LOGIN_CHECK, account);
            default:
                return false;
        }
    }
    isValidateCertificateOnTrading(authenticationType, account) {
        switch (authenticationType) {
            case AuthenticationType.CapitalFutures:
                return DataCache.isAllowedForAccount(RulesSet.CA_TRADE_CHECK, account);
            default:
                return false;
        }
    }
}
